import { coreInstance as axios, api } from 'settings';
import { logger } from 'helpers';
import * as actionTypes from './actionTypes';

const getProvidersNotifiableStart = () => {
	return {
		type: actionTypes.GET_PROVIDERS_NOTIFIABLE_START,
	};
};

const getProvidersNotifiableSuccess = (data) => {
	return {
		type: actionTypes.GET_PROVIDERS_NOTIFIABLE_SUCCESS,
		data: data,
	};
};

export const getProvidersNotifiable = (args = {}) => {
	const { successHandler, errorHandler } = args;

	return (dispatch) => {
		dispatch(getProvidersNotifiableStart());

		axios
			.get(api.providers_notifiable.index)
			.then((response) => {
				logger('[Action] Get models');
				dispatch(getProvidersNotifiableSuccess(response.data.data));
				successHandler && successHandler(response.data.data);
			})
			.catch(() => {
				logger('[Action] Get models fail');

				errorHandler && errorHandler();
			});
	};
};
